<div class="phone-numbers">
  <div class="phone-numbers__header">
    <h4 class="mb-2">{{ 'Settings::PhoneNumbers:Title' | abpLocalization }}</h4>
    <p class="text-muted mb-0">
      {{ 'Settings::PhoneNumbers:PageDescription' | abpLocalization }}
    </p>
  </div>

  <p-tabs [(value)]="activeTab" styleClass="phone-numbers__tabs">
    <p-tablist>
      <p-tab [value]="inboundTab">
        {{ 'Settings::PhoneNumbers:InboundNumbers' | abpLocalization }}
      </p-tab>
      <p-tab [value]="outboundTab">
        {{ 'Settings::PhoneNumbers:OutboundNumbers' | abpLocalization }}
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel [value]="inboundTab">
        <app-inbound-numbers-list (test)="onInboundTest($event)" />
      </p-tabpanel>
      <p-tabpanel [value]="outboundTab">
        <app-outbound-numbers-list (test)="onOutboundTest($event)" />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<app-phone-number-test-dialog
  [visible]="testDialogVisible"
  [phoneNumber]="testPhoneNumber"
  [kind]="testKind"
  [test$]="testRun$"
  [runToken]="testRunToken"
  (visibleChange)="onTestVisibleChange($event)" />
